import styled from 'styled-components';

const SelectStyled = styled.select`
  padding: 5px 20px;
  border: 1px solid #707070;
  border-radius: 18px;
  opacity: 1;
  &:nth-child(2){
    margin-left: 20px;
  }
`;

export default SelectStyled;
